import { createContext, useState } from "react"

export const AreaContext = createContext()

export const AreaProvider = ({ children }) => {
    const [areas, setAreas] = useState([])
  
    return (
        <AreaContext.Provider value={{ areas, setAreas }}>
            {children}
        </AreaContext.Provider>
    )
}